export enum SvcCacheName {
  ENVIRONMENT_INFO = 'ENVIRONMENT_INFO',
  APPS_MENU = 'APPS_MENU',
  LANGUAGE_TAG = 'LANGUAGE_TAG',
  TERMS = 'TERMS',
  ANONYMOUS_TERMS = 'ANONYMOUS_TERMS',
  SITES = 'SITES',
  AUTHENTICATED_LANGUAGES = 'AUTHENTICATED_LANGUAGES',
  CURRENCY = 'CURRENCY',
}
